import React from "react";
import ProjectForm from "../components/forms/ProjectForm"

const ProjectInformation: React.FC = () => {
  return (
   <>
   <div>
   <ProjectForm />
   </div>
   </>
  );
};

export default ProjectInformation;
